import { FC, Fragment, useCallback, useMemo, useState } from "react"

import If from "../../../../if"
import EventIcon from "./event-icon"
import EmailViewerModal from "../../../../email-viewer-modal"
import { LinkBtn } from "../../../../buttons"
import {
  capitalize,
  DEFAULT_DATETIME_SECONDS_SLASH_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../../utils"
import { SubscriptionEvent } from "../../../../../../types"

interface Props {
  data: SubscriptionEvent
  connectorVisible?: boolean
}

const EngagementEventLog: FC<Props> = ({ data, connectorVisible = true }) => {
  const [subscriptionId, setSubscriptionId] = useState<string | null>(null)
  const { type, timestamp, subscription_id } = data
  const eventText = useMemo(() => {
    return type === "intro_email_sent"
      ? "Intro Email"
      : type
          .split("_")
          .map(part => capitalize(part))
          .join(" ")
  }, [type])

  const handleOpenEmail = () => setSubscriptionId(subscription_id)

  const handleCloseEmail = useCallback(
    () => setSubscriptionId(null),
    [setSubscriptionId]
  )

  return (
    <Fragment>
      <div className="md:flex items-center justify-between py-3 md:max-w-3xl">
        <div className="flex items-center relative">
          <EventIcon type={type} color="#fff" />
          {connectorVisible && (
            <div className="absolute top-12 left-6 mt-1 -ml-[1px] w-0 h-4 border-2 border-neutral-400"></div>
          )}
          <div className="ml-4">
            <span>
              <If
                condition={type === "intro_email_sent"}
                then={
                  <Fragment>
                    <LinkBtn
                      theme="alt"
                      text="base"
                      className="hover:text-primary-500"
                      borderClassName="border-0 border-dashed border-neutral-400 border-b rounded-none"
                      paddingOff
                      onClick={handleOpenEmail}
                    >
                      <span className="font-bold">{eventText}</span>
                    </LinkBtn>
                    &nbsp;Sent
                  </Fragment>
                }
                else={eventText}
              />
            </span>
          </div>
        </div>

        <div className="text-neutral-400 ml-16 md:ml-0 mt-2 md:mt-0">
          {formatDateTimeFromTimestamp(
            timestamp,
            DEFAULT_DATETIME_SECONDS_SLASH_FORMAT
          )}
        </div>
      </div>

      <EmailViewerModal
        open={!!subscriptionId}
        subscriptionId={subscriptionId!}
        title="Intro email"
        noDataText="No intro email found."
        onClose={handleCloseEmail}
      />
    </Fragment>
  )
}

export default EngagementEventLog
